import { all, call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestSamples } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTSAMPLE,
  ADD_NEW_LABREQUESTSAMPLECONTROL,
  ADD_NEW_LABREQUESTSAMPLEPROCESS,
  DELETE_LABREQUESTSAMPLE,
  GET_LABREQUESTSAMPLE,
  GET_LABREQUESTSAMPLES,
  UPDATE_LABREQUESTSAMPLE,
  UPDATE_LABREQUESTSAMPLECHECK,
  MASSIVE_SAMPLE_STATUS_UPDATE,
  MASSIVE_SAMPLE_STATUS_UPDATE_SUCCESS,
  MASSIVE_SAMPLE_STATUS_UPDATE_FAIL,
} from "./actionTypes";
import {
  addLabRequestSampleControlFail,
  addLabRequestSampleControlSuccess,
  addLabRequestSampleFail,
  addLabRequestSampleProcessFail,
  addLabRequestSampleProcessSuccess,
  addLabRequestSampleSuccess,
  deleteLabRequestSampleFail,
  deleteLabRequestSampleSuccess,
  getLabRequestSampleFail,
  getLabRequestSamplesFail,
  getLabRequestSamplesSuccess,
  getLabRequestSampleSuccess,
  setState,
  updateLabRequestSampleCheck,
  updateLabRequestSampleFail,
  updateLabRequestSampleSuccess,
  massiveSampleStatusUpdateSuccess,
  massiveSampleStatusUpdateFail,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequestSamples( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,labRequestSamples, params.toString());
    yield put(setState(false))
    yield put(getLabRequestSamplesSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestSamplesFail(error));
  }
}

function* fetchLabRequestSampleById( { payload: { params } } ) {
  try {
    const response = yield call(getTable,labRequestSamples, params.toString());
    yield put(getLabRequestSampleSuccess(response));
  } catch (error) {
    yield put(getLabRequestSampleFail(error));
  }
}

function* updateLabRequestSample ({payload: labRequestSampleObj }) {
  try {
    const { id, ...rest } = labRequestSampleObj;
    yield call(patchApiCall, `${labRequestSamples}/${id}`, rest);
    const response = yield call(getTable,`${labRequestSamples}/${labRequestSampleObj.id}`);
    yield put(updateLabRequestSampleSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateLabRequestSampleFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteLabRequestSample ({payload: labRequestSampleObj}) {
  try {
    yield call(deleteApiCall,`${labRequestSamples}/${labRequestSampleObj.id}` );
    yield put(deleteLabRequestSampleSuccess(labRequestSampleObj.id));
    toast.success('Registro borrado correctamente')

  } catch (error) {
    yield put(deleteLabRequestSampleFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestSample ({ payload: labRequestSample}) {
  try {
    const response = yield call(postApiCall, labRequestSamples ,labRequestSample);
    const response2 = yield call(getTable,`${labRequestSamples}/${response.id}`);
    yield put(addLabRequestSampleSuccess(response2));
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(addLabRequestSampleFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* postingLabRequestSampleProcess ({ payload: labRequestSample}) {
  try {
    const response = yield call(postApiCall, `${labRequestSamples}/samples-to-process`, labRequestSample);
    const { updatedCount } = response;
    yield put(addLabRequestSampleProcessSuccess());
    if (updatedCount === 0) {
      toast.info("No se encontraron muestras por actualizar.");
      return;
    }
    toast.success(`Se actualizaron ${updatedCount} muestras`);
  } catch (error) {
    yield put(addLabRequestSampleProcessFail(error));
  }
}

function* postingLabRequestSampleControl ({ payload: labRequestSample}) {
  try {
    const response = yield call(postApiCall, `${labRequestSamples}/samples-to-process`, labRequestSample);
    const { updatedCount } = response;
    if (updatedCount === 0) {
      toast.info("No se encontraron muestras por actualizar.");
      return;
    }
    toast.success(`Se actualizaron ${updatedCount} muestras`);
    // yield all(labRequestSample?.labRequestSamples?.map(element => {
    //   return put(addLabRequestSampleControlSuccess(element))
    // }));
    console.log(addLabRequestSampleControlSuccess(0))
  } catch (error) {
    yield put(addLabRequestSampleControlFail(error));
  }
}

function* massiveLabRequestSampleStatusUpdate({ payload: { labRequestId, validationValues } }) {
  try {
    yield put(setState(true));

    const { statusValidation, receiverUser, receivedAt, validateObservations } = validationValues;
    let endpoint = `${labRequestSamples}/massive/status-update?labRequest=${labRequestId}`;
    if (statusValidation) endpoint += `&validationStatus=${statusValidation}`;
    if (receiverUser) endpoint += `&receiverUser=${receiverUser}`;
    if (receivedAt) endpoint += `&receivedAt=${receivedAt}`;
    if (validateObservations) endpoint += `&validateObservations=${encodeURIComponent(validateObservations)}`;

    const response = yield call(patchApiCall, endpoint);
    const { updatedCount } = response;

    yield put(massiveSampleStatusUpdateSuccess());
    if (updatedCount === 0) {
      toast.info("No se encontraron muestras para actualizar el estado.");
      return;
    }
    toast.success(`Estado de ${updatedCount} muestras actualizado correctamente`);
  } catch (error) {
    yield put(massiveSampleStatusUpdateFail(error));
    toast.error("Error al actualizar el estado de las muestras");
  } finally {
    yield put(setState(false));
  }
}

function* labRequestSamplesSaga() {
  yield takeEvery(GET_LABREQUESTSAMPLES, fetchLabRequestSamples);
  yield takeEvery(ADD_NEW_LABREQUESTSAMPLE, postingLabRequestSample);
  yield takeEvery(ADD_NEW_LABREQUESTSAMPLEPROCESS, postingLabRequestSampleProcess);
  yield takeEvery(ADD_NEW_LABREQUESTSAMPLECONTROL, postingLabRequestSampleControl);
  yield takeEvery(UPDATE_LABREQUESTSAMPLE, updateLabRequestSample);
  yield takeEvery(UPDATE_LABREQUESTSAMPLECHECK, updateLabRequestSampleCheck);
  yield takeEvery(DELETE_LABREQUESTSAMPLE, deleteLabRequestSample);
  yield takeEvery(GET_LABREQUESTSAMPLE, fetchLabRequestSampleById);
  yield takeEvery(MASSIVE_SAMPLE_STATUS_UPDATE, massiveLabRequestSampleStatusUpdate);
}

export default labRequestSamplesSaga;
